// Meta Pixel (consent-gated, runtime-configurable) + UTM / attribution helpers.
import { hasMarketingConsent } from "./consent";

let pixelId = process.env.REACT_APP_META_PIXEL_ID || "";
let loaded = false;
let pageViewSent = false;

export function configurePixel(id) {
  pixelId = (id || "").trim();
}

export function getPixelId() {
  return pixelId;
}

function loadFbq() {
  if (window.fbq) return;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
}

function log(event, params) {
  window.__mboPixelEvents = window.__mboPixelEvents || [];
  window.__mboPixelEvents.push({ event, params, at: Date.now() });
}

// Loads the pixel and fires PageView once, only when an ID exists and marketing consent is granted.
export function initPixel() {
  if (!pixelId || !hasMarketingConsent()) return false;
  if (!loaded) {
    loadFbq();
    window.fbq("init", pixelId);
    loaded = true;
  }
  if (!pageViewSent) {
    window.fbq("track", "PageView");
    log("PageView");
    pageViewSent = true;
  }
  return true;
}

function track(event, params = {}, options) {
  if (!initPixel() || !window.fbq) return false;
  if (options?.eventID) window.fbq("track", event, params, { eventID: options.eventID });
  else window.fbq("track", event, params);
  log(event, params);
  return true;
}

export function trackViewContent(product) {
  return track("ViewContent", {
    content_name: product.name,
    content_ids: [String(product.id)],
    content_type: "product",
    content_category: product.cat,
  });
}

export function trackContact(method) {
  return track("Contact", { content_name: method });
}

// Fired only after the backend confirmed the lead was saved; deduped per session via eventID.
export function trackLead(eventId) {
  const key = "mbo_lead_tracked";
  if (sessionStorage.getItem(key)) return false;
  const ok = track("Lead", { content_name: "Richiedi accesso" }, { eventID: eventId });
  if (ok) sessionStorage.setItem(key, eventId);
  return ok;
}

export function newEventId() {
  return window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function cookie(name) {
  return document.cookie.split("; ").find((r) => r.startsWith(`${name}=`))?.split("=")[1] || null;
}

export function getFbCookies() {
  return { fbp: cookie("_fbp"), fbc: cookie("_fbc") };
}

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const stored = JSON.parse(sessionStorage.getItem("mbo_attr") || "{}");
    const attr = { ...stored };
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) attr[k] = v;
    });
    if (!attr.referrer) attr.referrer = document.referrer || "";
    attr.landing_url = window.location.href;
    sessionStorage.setItem("mbo_attr", JSON.stringify(attr));
    return attr;
  } catch (e) {
    return {};
  }
}

export function getTrackingPayload() {
  const attr = captureAttribution();
  return {
    utm_source: attr.utm_source || null,
    utm_medium: attr.utm_medium || null,
    utm_campaign: attr.utm_campaign || null,
    utm_content: attr.utm_content || null,
    utm_term: attr.utm_term || null,
    referrer: attr.referrer || null,
    landing_url: attr.landing_url || window.location.href,
    device: navigator.userAgent || null,
    client_timestamp: new Date().toISOString(),
  };
}
